import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { Box, BoxProps, SxProps, Theme } from '@mui/material';
import { ReactNode } from 'react';

interface YesNoPillProps extends Omit<BoxProps, 'children'> {
  value: boolean;
  trailing?: ReactNode;
}

export const YesNoPill = ({ value, trailing, sx, ...props }: YesNoPillProps) => (
  <Box
    data-yes-no-value={value ? 'true' : 'false'}
    sx={[getPillSx, sx ?? false] as SxProps<Theme>}
    {...props}
  >
    {value ? <CheckIcon /> : <CloseIcon />}
    {value ? 'Yes' : 'No'}
    {trailing}
  </Box>
);

function getPillSx(theme: Theme): SxProps<Theme> {
  return {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.25rem',
    padding: '0.125rem 0.625rem',
    borderRadius: '999px',
    fontSize: '0.8rem',
    fontWeight: 500,
    lineHeight: 1.4,
    '&[data-yes-no-value="true"]': {
      backgroundColor: theme.palette.custom.OV.sys.successContainer,
      color: theme.palette.custom.OV.sys.onSuccessContainer,
    },
    '&[data-yes-no-value="false"]': {
      backgroundColor: theme.palette.custom.OV.sys.errorContainer,
      color: theme.palette.custom.OV.sys.onErrorContainer,
    },
    '& .MuiSvgIcon-root': {
      fontSize: '0.95rem',
    },
  };
}
